import Logo from '../../../LoginPage/components/PreLogin/logo.svg';
import Point1 from '../../../LoginPage/components/PreLogin/point-1.webp';
import Point2 from './point-2.webp';
import { CaretCircleRightIcon } from '../../../../components/Icons/icons';
import { motion } from 'framer-motion';
import button from '../../../../components/Button/Button.module.scss';
import s from '../../../RegisterPage/components/PreRegister/PreRegister.module.scss';
import card from '../../../../components/Card/FlexCard.module.scss';
import globalColors from '../../../../styles/_colors.scss';
import { useNavigate } from 'react-router-dom';
import { ScaleX } from '../../../../components/Animations/PageTransitions';
import Button from '../../../../components/Button/Button';
import {
  RevealCard,
  revealVariants,
} from '../../../../components/Animations/CardTransitions';
import {
  h1Variants,
  h4Variants,
} from '../../../../components/Animations/TextTransitions';

const PreRegister = () => {
  const navigate = useNavigate();
  return (
    <>
      <motion.div
        initial='hidden'
        animate='visible'
        exit={{ opacity: 0, transition: { duration: 1 } }}
      >
        <div className={s.header}>
          <img src={Logo} alt='logo' />
          <motion.h1 variants={h1Variants}>Rejestracja</motion.h1>
          <Button
            style={{ width: '165px', height: '40px' }}
            className={`${button.button} ${button.register}`}
            icon={<CaretCircleRightIcon />}
            onClick={() => navigate('/register')}
          >
            <p className='button-4'>Zarejestruj się</p>
          </Button>
          <motion.h4
            variants={h4Variants}
            style={{ color: globalColors.gray7 }}
          >
            Odkrywaj talenty swojego dziecka z Panem Tabletem.<br></br>Zaloguj
            się, by otrzymać wszystkie materiały!
          </motion.h4>
        </div>
        <div className={s.wrapper}>
          <div className={card.allCards}>
            <RevealCard>
              <motion.div variants={revealVariants} className={card.singleCard}>
                <div className={s.cardWrapper}>
                  <div className={s.cardUpper}>
                    <img src={Point1} alt='point-1' />
                  </div>
                  <div className={s.cardBottom}>
                    <h2>Co dają lekcje Pana Tableta?</h2>
                    <p className='body-2'>
                      Na zajęciach dzieci uczą się korzystać z nowych
                      technologii i tworzą swoje multimedialne prace. Zajęcia
                      rozbudzają zainteresowania i aktywność twórczą, a prace
                      dzieci zbierane i prezentowane są na tej platformie!
                    </p>
                  </div>
                </div>
              </motion.div>
            </RevealCard>
            <RevealCard>
              <motion.div variants={revealVariants} className={card.singleCard}>
                <div className={s.cardWrapper}>
                  <div className={s.cardUpper}>
                    <img src={Point2} alt='point-2' />
                  </div>
                  <div className={s.cardBottom}>
                    <h2>Jakie korzyści daje logowanie?</h2>
                    <p className='body-2'>Tylko zalogowany użytkownik:</p>
                    <p className='body-2'>
                      - ma możliwość oddania głosu w konkursie;
                    </p>
                    <p className='body-2'>
                      - może korzystać z wszystkich dostępnych materiałów na
                      stronie;
                    </p>
                    <p className='body-2'>
                      - może polubić, udostępnić i skomentować pracę dziecka.
                    </p>
                  </div>
                </div>
              </motion.div>
            </RevealCard>
          </div>
        </div>
      </motion.div>
      <ScaleX color={globalColors.green1} />
    </>
  );
};

export default PreRegister;
